import React, { Component } from "react";
// import QRCode from 'qrcode.react';

class PaymentReceipt extends Component {
  getUserReferenceNumber(users) {
    let refNumber;
    Object.entries(users).map((user) => {
      if (user[0] === this.props.loggedInUser) {
        refNumber = user[1].paymentReference;
      }
    });
    return refNumber;
  }
  renderUsersListItems(users) {
    let itemsPaidfor = []; let itemTotal = 0;
    Object.entries(users).map((user) => {
      if (user[0] === this.props.loggedInUser) {
        Object.values(user[1]).forEach((data) => {
          if (data.itemsPaidFor) {
            Object.values(data.itemsPaidFor).map((name) => {
              itemTotal = itemTotal + parseInt(name.total, 10);
              itemsPaidfor.push(
                <li className="">
                  <span className="name">{name.name}</span>
                  <span className="price">${(name.total / 100).toFixed(2)}</span>
                </li>
              );
            });
          }
        });
      } else {
        return;
      }
    });

    itemTotal = (itemTotal / 100).toFixed(2);
    return { itemsPaidfor, itemTotal };
  }
  renderListItems(items) {
    let data = [];
    items.forEach((item) => {
      data.push(<li className="">
        <span className="name">{item.name}</span>
        <span className="price">${(item.total / 100).toFixed(2)}</span>
      </li>)
    });
    return data;
  }
  render() {
    let paymentReferenceNumber = this.getUserReferenceNumber(this.props.users);
    let itemStats = this.renderUsersListItems(this.props.users);
    return (
      <div className="container">
        <div className="row">
          <div className="receiptContainer col-sm-12">
            {
              (this.props.type === "splitequally") &&
              <div className="receiptContents">
                <h6>Receipt</h6>
                <p className="datetime">Date: {this.props.currentDate}</p>
                <p className="referenceNumber">Ref: #{paymentReferenceNumber}</p>
                <hr />
                <div className="receiptContents">
                  <ul className="receiptItemList">
                    <p>Your share of the bill has been paid</p>
                    <h2><i className="fa fa-check green"></i></h2>
                    <hr />
                    <li>
                      <span className="name">No of Guests on Table </span>
                      <span className="price totalprice"><strong>{this.props.splitByTotalUsers}</strong></span>
                    </li>
                    <li>
                      <span className="name">Table Total</span>
                      <span className="price totalprice"><strong>${this.props.tableTotal}</strong></span>
                    </li>
                    <li>
                      <span className="name">Split Bill Total</span>
                      <span className="price totalprice"><strong>${this.props.splitBillTotal}</strong></span>
                    </li>
                  </ul>
                </div>
              </div>
            }
            {

              (this.props.type === 'paybyitems') &&
              <div className="receiptContents">

                {
                  (itemStats.itemTotal === "0.00") ? [
                    <h2><i className="fa fa-check green"></i></h2>,
                    <p>The Bill for the table has been paid completely.</p>
                  ] : [
                      <h6>Receipt</h6>,
                      <p className="datetime">Date: {this.props.currentDate}</p>,
                      <hr />,
                      <div className="receiptContents">
                        <ul className="receiptItemList">
                          {itemStats.itemsPaidfor}
                          <hr />
                          <li>
                            <span className="name">Table Total</span>
                            <span className="price totalprice"><strong>${this.props.tableTotal}</strong></span>
                          </li>
                          <hr />
                          <li>
                            <span className="name">Your Item Total</span>
                            <span className="price totalprice"><strong>${itemStats.itemTotal}</strong></span>
                          </li>
                          <h2><i className="fa fa-check green"></i></h2>
                          <p>Your payment has been made successfully</p>

                        </ul>
                      </div>
                    ]
                }


              </div>
            }
            {
              //<QRCode value={paymentReferenceNumber} size={75} />
            }
          </div>
        </div>
      </div>
    )
  }
}
export default PaymentReceipt;


// WEBPACK FOOTER //
// ./src/Components/PaymentReceipt.js